import { apiSlice } from "../app/api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllGroups: builder.query({
      query: (id_season) => ({
        url: `/groups/get-all-groups/${id_season}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      providesTags: ['Group', 'User', 'Inscription']
    }), 
    insertGroupTraining: builder.mutation({
      query: data => ({
          url: `/groups/insert-group-training`,
          method: 'POST',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['Group', 'User', 'Inscription']
    }),
    deleteGroupTraining: builder.mutation({
      query: ({ id_group_training }) => ({
          url: `/groups/delete-group-training/${id_group_training}`,
          method: 'DELETE'
      }),
      invalidatesTags: ['Group', 'User', 'Inscription']
    }),
  })
})


export const { 
  useGetAllGroupsQuery, useInsertGroupTrainingMutation, useDeleteGroupTrainingMutation
} = userApiSlice